<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">
    Update {{ application.appName }} - {{ application.appVersionText }}
  </h4>
  <i
    style="z-index: 1"
    class="bi bi-x-lg text-danger"
    color="warn"
    (click)="onClose()"
    title="Close"
  ></i>
</div>
<div class="modal-body pb-0 text-grey">
  <form name="updateApplicationForm"
        [formGroup]="updateApplicationForm"
        (ngSubmit)="onSubmit(updateApplicationForm)"
        autocomplete="off"
        spellcheck="false">

    <div class="grid-view">
      <mat-form-field>
        <mat-label>Modules</mat-label>
        <input matInput
               title="Add one or multiple comma module names"
               placeholder="Modules"
               formControlName="modulesApp" />
      </mat-form-field>
  
      <mat-form-field appearance="fill">
        <mat-label>Add MPI</mat-label>
        <mat-select formControlName="appMpi">
          <mat-option *ngFor="let mpi of mpis" [value]="mpi">
            {{
            mpi.name
            }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="
            updateApplicationForm.get('appMpi').touched &&
            updateApplicationForm.get('appMpi').errors
          ">Required</mat-error>
      </mat-form-field>
  
      <mat-form-field appearance="fill">
        <mat-label>License Check</mat-label>
        <mat-select formControlName="licenseCheck">
          <mat-option *ngFor="let flag of licenseCheckFlags" [value]="flag">
            {{
            flag.name
            }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="
            updateApplicationForm.get('licenseCheck').touched &&
            updateApplicationForm.get('licenseCheck').errors
          ">Required</mat-error>
      </mat-form-field>
  
      <mat-form-field appearance="fill">
        <mat-label>Fabric</mat-label>
        <mat-select formControlName="fabricCheck">
          <mat-option *ngFor="let fabric of fabrics" [value]="fabric">
            {{
            fabric.name
            }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="
            updateApplicationForm.get('fabricCheck').touched &&
            updateApplicationForm.get('fabricCheck').errors
          ">Required</mat-error>
      </mat-form-field>
  
      <mat-form-field>
        <mat-label>Static Cores</mat-label>
        <input matInput
               title="Add comma separated cores with which user will be able to submit job from available cores, if empty job can be submitted with any number of cores."
               placeholder="Static Cores"
               formControlName="staticCores" />
        <mat-error *ngIf='updateApplicationForm.get("staticCores").touched && updateApplicationForm.get("staticCores").errors?.pattern'>Only comma separated numbers allowed.</mat-error>
      </mat-form-field>
  
      <mat-form-field>
        <mat-label>Node Groups</mat-label>
        <mat-select
          formControlName="applicationSpecificQueue"
          [(ngModel)]="alreadyAttachedNodeGroups"
          multiple
        >
          <mat-option
            type="checkbox"
            *ngFor="let node of queuesFromDep"
            [value]="node"
            >{{ node }}</mat-option
          >
        </mat-select>
      </mat-form-field>
  
      <mat-form-field matTooltip="" matTooltipPosition="above">
        <mat-label>Enter default memory space per CPU(in GB), e.g 1</mat-label>
        <input matInput
               type="number"
               placeholder="Enter default memory space per CPU(in GB), e.g 1"
               formControlName="defaultMemorySpace" />
        <mat-error *ngIf="
            updateApplicationForm.get('defaultMemorySpace').touched &&
            updateApplicationForm.get('defaultMemorySpace').errors?.pattern
          ">Please enter minimum scratch space (in GB), e.g 1. Enter only positive numbers.</mat-error>
      </mat-form-field>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Close</button>
      <button [disabled]="submitActive"
              type="submit" class="btn btn-primary">
        Submit
      </button>
    </div>
  </form>
</div>
